import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {IonicModule} from "@ionic/angular";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {YesNoInputComponent} from "./yes-no-input.component";
import {CheckboxInputModule} from "../../checkbox/checkbox-input/checkbox-input.module";
import {YesNoPipeModule} from "../../../../modules/core/pipe/yes-no.pipe";
import {MatRadioModule} from "@angular/material/radio";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        ReactiveFormsModule,
        MatCheckboxModule,
        CheckboxInputModule,
        YesNoPipeModule,
        MatRadioModule
    ],
    declarations: [
        YesNoInputComponent,
    ],
    exports: [
        YesNoInputComponent
    ]
})
export class YesNoInputModule {}
